import React from "react";
import Image from "next/image";

const CustomNextImage = ({
  src,
  alt,
  width,
  height,
  className,
  onClick,
  style,
  priority,
}) => {
  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      onClick={onClick}
      style={style}
      className={className}
      priority={priority}
      // fetchPriority="high"
    />
  );
};

export default CustomNextImage;
